var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTroy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.668 13.12a.41.41 0 0 1 .29-.12h4.768a.41.41 0 0 1 .29.12l.535.535a.41.41 0 0 1 .121.29v1.973a.41.41 0 0 1-.12.29l-.533.535a.41.41 0 0 1-.29.12H13.58l1.97 1.97a.41.41 0 1 1-.58.58l-2.672-2.67a.41.41 0 0 1 .29-.702h1.968l.293-.292v-1.633l-.294-.293h-4.427l-.294.293v5.09a.41.41 0 0 1-.822 0v-5.26a.41.41 0 0 1 .12-.29l.534-.535zm7.932 0a.41.41 0 0 1 .29-.12h4.398a.41.41 0 0 1 .29.12l.535.535a.41.41 0 0 1 .12.29v4.439a.41.41 0 0 1-.078.24l-.534.74a.41.41 0 0 1-.332.17h-4.192a.41.41 0 0 1-.29-.12l-.74-.74a.41.41 0 0 1-.12-.29v-4.439a.41.41 0 0 1 .12-.29l.534-.535zm.46.702-.293.293v4.098l.5.5h3.81l.334-.462v-4.135l-.293-.293h-4.056zM30.59 13a.41.41 0 0 1 .41.41v2.302a.41.41 0 0 1-.12.29l-.535.535a.41.41 0 0 1-.29.12H28.41v2.425a.41.41 0 1 1-.82 0v-2.425h-1.933a.41.41 0 0 1-.29-.12l-.534-.534a.41.41 0 0 1-.12-.29V13.41a.41.41 0 1 1 .821 0v2.132l.294.294h4.057l.293-.294v-2.13a.41.41 0 0 1 .41-.412zm-29.18.164a.41.41 0 1 0 0 .822h2.57v5.178a.41.41 0 0 0 .821 0v-5.178h2.57a.41.41 0 0 0 0-.822H1.41z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTroy);
export default __webpack_public_path__ + "static/media/TROY.ef906cef4091308d46b88b40e53d669c.svg";
export { ForwardRef as ReactComponent };